import { Divider, Form } from "antd";
import PrimaryButton from "components/Buttons/PrimaryButton/PrimaryButton";
import TextInput from "components/Inputs/TextInput/TextInput";
import useMessage from "hooks/useMessage";
import { t } from "i18next";
import PageLayout from "layout/PageLayout/PageLayout";
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "redux/features/app/authTokenSlice";
import { getFeaturesSettings } from "redux/features/app/featuresSettingSlice";
import centralApi from "services/centralApi";
import { API_ENDPOINTS } from "utils/constants";
import { ApmConfig } from "utils/models";

interface APMProps {}

const APM: FC<APMProps> = ({}) => {
    const apmConfig =  useSelector((state: any) => state.featuresSetting?.data[0]?.apmConfig);
    const loginUser = useSelector((state: any) => state.loginUser.data);
    const { appId } = useSelector((state: any) => state.activeApp);
    const dispatch: any = useDispatch();
    const {showError,showSuccess}=useMessage()
    const handleOnSave = async (data:ApmConfig) => {
        try {
          const authToken = await dispatch(getToken()).unwrap();
          const config= new ApmConfig(data)
          const payload = {
            config:config.toString(),
            app_id: appId,
            api_key: loginUser.api_key,
            authToken,
          };
          await centralApi("POST", API_ENDPOINTS.SAVE_APM_CONFIG_URL, payload);
          dispatch(getFeaturesSettings({app_id:appId,api_key:loginUser.api_key}))
          showSuccess(t("sucessfullySavedLabel"))
        } catch (error) {
          showError(t("somethingWrongLabel"))
    
        }
      };
  return (
    <PageLayout>
      <div className="mb-4">
        <h6>{t("apmSettingsLabel")}</h6>
        <Divider />
      </div>
      <Form layout="vertical"  onFinish={handleOnSave} initialValues={apmConfig}>
        <Form.Item
          name="url"
          label={`${t("apiUrlLabel")}`}
          rules={[{ required: true, message: `${t("plzEnterApiUrlMsg")}` }]}
        >
          <TextInput />
        </Form.Item>

        <Form.Item
          name="token"
          label={`${t("apiTokenLabel")}`}
          rules={[{ required: true, message: `${t("plzEnterApiTokenMsg")}` }]}
        >
          <TextInput />
        </Form.Item>

        <Form.Item
          name="apiVersion"
          label={t("apiVersionLabel")}
          rules={[{ required: true, message: `${t("plzEnterApiVersionMsg")}` }]}
        >
          <TextInput />
        </Form.Item>

        <Form.Item
          name="projectId"
          label={t("projectIdLabel")}
          rules={[{ required: true, message: `${t("plzEnterProjectIdMsg")}` }]}
        >
          <TextInput />
        </Form.Item>

        <Form.Item
          name="projectName"
          label={t("projectNameLabel")}
          rules={[
            { required: true, message: `${t("plzEnterProjectNameMsg")}` },
          ]}
        >
          <TextInput />
        </Form.Item>

        <Form.Item>
          <PrimaryButton type="primary" htmlType="submit">
            {t("saveLabel")}
          </PrimaryButton>
        </Form.Item>
      </Form>
    </PageLayout>
  );
};

export default APM;
